<p-toast position="top-center">
  <ng-template pTemplate="message" let-message>
    <div (click)="onMessageClick(message)">
      <span
        class="p-toast-message-icon"
        [ngClass]="'p-toast-icon-' + message.severity"
      ></span>
      <div class="p-toast-message-text">
        <span *ngIf="message.summary" class="p-toast-summary">{{
          message.summary | translate
        }}</span>
        <div class="p-toast-detail">
          {{ message.detail | translate }}
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
